// Cache duration: 1 hour in milliseconds
export const CACHE_DURATION = 60 * 60 * 1000;

/**
 * Check if cached data is still valid
 * @param {number|null} lastFetched - timestamp of last fetch
 * @returns {boolean} true if cache is still valid
 */
export function isCacheValid(lastFetched) {
  if (!lastFetched) return false;
  return Date.now() - lastFetched < CACHE_DURATION;
}

/**
 * Generate a cache key from filters object
 */
export function getCacheKey(filters = {}) {
  return JSON.stringify(filters);
}


const utility = {
  CACHE_DURATION,
  isCacheValid,
  getCacheKey
};

// Default export for backward compatibility
export default utility;